export default __webpack_public_path__ + "static/platform3-a2a98174db6117e333ffa2ca56655ae7.svg";